// Company hero only: the picture drifts as the hero scrolls away, and on a computer
// the doors below slide up over its last 36px (consumer-company-doors.css sets that
// overlap only when the doors follow this hero). Scroll reveal for the rest of the
// page is consumer-company-reveal.js.
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const hero = document.querySelector('.val-company');
  if (!hero) return;

  const stage = hero.querySelector('.val-company__stage') || hero;
  const pan = hero.querySelector('.val-company__visual-pan');
  const doors = document.querySelector('.val-doors');
  const desktopQuery = window.matchMedia('(min-width: 1101px)');

  let ticking = false;
  const update = function () {
    ticking = false;
    const rect = stage.getBoundingClientRect();
    const height = Math.max(rect.height, 1);
    const progress = Math.min(1, Math.max(0, -rect.top / height));
    hero.style.setProperty('--val-hero-progress', progress.toFixed(3));

    if (pan) {
      const amount = desktopQuery.matches ? 12 : 8;
      pan.style.transform = 'translate3d(0,' + (progress * amount).toFixed(2) + '%,0)';
    }

    if (doors) {
      const rise = desktopQuery.matches ? 36 : 24;
      doors.style.setProperty('--doors-rise', ((1 - progress) * rise).toFixed(1) + 'px');
    }
  };

  window.addEventListener(
    'scroll',
    function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    },
    { passive: true }
  );

  update();
})();
